import axios from "axios";

const createAxios = axios.create({
  baseURL: process.env.REACT_APP_HOST || "",
  headers: {
    "Content-Type": "application/json",
  },
});

const redirectTo404 = () => {
  if (window.location.pathname !== "/404") {
    window.location.replace("/404");
  }
};

const TOKEN_EXPIRY_TIME = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

const isTokenExpired = () => {
  const tokenTimestamp = localStorage.getItem("access_token_timestamp");
  if (!tokenTimestamp) return false;
  return Date.now() - parseInt(tokenTimestamp) > TOKEN_EXPIRY_TIME;
};

const clearToken = () => {
  document.cookie = "access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  localStorage.removeItem("access_token_timestamp");
};


// Response interceptor
createAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 405 || error.response?.status === 402) {
      // Token expired or invalid
      clearToken();
      window.location.href = "/dashboard/login"; // Redirect to login page
    }
    if (error?.response?.status === 404) {
      redirectTo404();
    }
    return Promise.reject(error);
  }
);

export default createAxios;
